// libs
import React, { memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// utils
import { getCloudinaryUrl } from "@swiggy-private/js-utils";

// styled components
import {
    StyledProductItem,
    ProductImageContainer,
    StyledImage,
    ProductDetailsContainer,
    ProductPricingContainer,
    StrikeThroughText,
} from "./styled";

interface ProductItemProps {
    product: {
        finalPrice: string;
        imageId: string;
        name: string;
        quantity: string;
        strikeThroughPrice: string;
    };
}

const imgDimensions = { width: 100, height: 100 };

const ProductItem: React.FC<ProductItemProps> = ({ product }) => {
    const { name, quantity, strikeThroughPrice, finalPrice, imageId } = product;

    return (
        <StyledProductItem cornerRadius="medium">
            <ProductImageContainer>
                <StyledImage src={getCloudinaryUrl(imageId, imgDimensions)} alt={name} />
            </ProductImageContainer>
            <ProductDetailsContainer>
                <Text variant="V2.body3.neutral.medium" color="text_Highest_Emphasis" maxLines={2}>
                    {name}
                </Text>
                <Text variant="V2.overline.neutral.medium" color="text_Low_Emphasis">
                    {quantity}
                </Text>
            </ProductDetailsContainer>
            <ProductPricingContainer>
                {strikeThroughPrice && (
                    <StrikeThroughText variant="V2.overline.neutral.medium" color="text_Low_Emphasis">
                        {strikeThroughPrice}
                    </StrikeThroughText>
                )}
                <Text variant="V2.body2.neutral.medium" color="text_Highest_Emphasis">
                    {finalPrice}
                </Text>
            </ProductPricingContainer>
        </StyledProductItem>
    );
};

export default memo(ProductItem);
